import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './ReviewRepliesList.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const ReviewRepliesList = () => {

    const [submissions, setSubmissions] = useState([]);
    const [selectedSubmissionId, setSelectedSubmissionId] = useState('');
    const [reviews, setReviews] = useState([]);
    //Sujay 10/6/2025 Adding the isParent var beacause We need to hide the accept reject resubmit btn if paper has a revision for it
    //if paper is parent then it will give true 
    const [isParent, setIsParent] = useState(false);
    const [summary, setSummary] = useState({ Accepted: 0, AcceptWithComment: 0, totalReject: 0 });
    const [btnsVisiable, setBtnsVisiable] = useState({ accept: false, revision: false, reject: false })
    //sujay 24/5/2025 adding here variable of handle the view to list to matrix or matrix to list
    //const [isList, setIsList] = useState(true);
    const [revisionBtnName, setRevisionBtnName] = useState("Revision");
    const API = process.env.REACT_APP_API_BASE_URL;

    //sujay 18/6/2025 Adding the variables to store the authors 
    const [authors, setAuthors] = useState([]);
    const [selectedAuthorId, setSelectedAuthorId] = useState(null);

    //  Search states for Author and Submission dropdowns
    const [authorSearch, setAuthorSearch] = useState('');
    const [showAuthorDropdown, setShowAuthorDropdown] = useState(false);

    const [submissionSearch, setSubmissionSearch] = useState('');
    const [showSubmissionDropdown, setShowSubmissionDropdown] = useState(false);


    //sujay 3/7/2025 cheaking that paper isReview or not
    const [isReview, setIsReview] = useState('');
    const platformId = localStorage.getItem('platformID')
    const navigate = useNavigate();
    const location = useLocation();


    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            toolbarSlot: (slots) => {
                const { Download, ...rest } = slots;
                return { ...rest };
            },
        },
    });

    // 🟢 NEW FILTER STATES
    const [filterStatus, setFilterStatus] = useState('All'); // All, Pending, Accept, Reject
    const [filterType, setFilterType] = useState('All'); // All, Abstract, Full_Paper, Revision


    useEffect(() => {
        if (location.state) {
            const { filterStatus: statusFromState, filterType: typeFromState } = location.state;
            if (statusFromState) setFilterStatus(statusFromState);
            if (typeFromState) setFilterType(typeFromState);
        }
    }, [location.state]);


    //Sujay 18/6/2025 get the submission by the author wise
    //this Api is written in the subassignmentRoute but for the rewrite the api again therefore i use here to avoid repetion

    useEffect(() => {
        axios.get(`${API}/api/subassignments/authors`)
            .then(res => setAuthors(res.data))
            .catch(err => console.error(err));
    });

    //get the submission by selected author and platfrom
    useEffect(() => {
        if (selectedAuthorId) {
            // 🟢 Added filter logic for Status and Type
            axios.get(`${API}/api/review-replies/submissions/${selectedAuthorId}/${platformId}`)
                .then(res => {
                    let filtered = res.data;
                    // console.log(res)

                    // Apply frontend filters
                    if (filterStatus !== 'All') {
                        filtered = filtered.filter(s => s.Status === filterStatus);
                    }

                    if (filterType !== 'All') {
                        filtered = filtered.filter(s =>
                            s.SubmissionTitle &&
                            s.SubmissionTitle.toLowerCase().includes(filterType.toLowerCase())
                        );
                    }

                    setSubmissions(filtered);
                })
                .catch(err => console.error(err));
        }
    }, [selectedAuthorId, filterStatus, filterType]);




    useEffect(() => {
        if (!selectedSubmissionId) return;

        axios.get(`${API}/api/review-replies/reviews/${selectedSubmissionId}`)
            .then(res => {
                console.log('res', res.data);

                const reviewsData = res.data.reviews || [];
                setReviews(reviewsData);
                setIsParent(res.data.isParent);
                setIsReview(res.data.isReview);

                // Track first unique decisions per reviewer
                const decisionsByReviewer = new Map();
                reviewsData.forEach(r => {
                    const prev = decisionsByReviewer.get(r.ReviewerID) || new Set();
                    if (!prev.has(r.Decision)) prev.add(r.Decision);
                    decisionsByReviewer.set(r.ReviewerID, prev);
                });

                // Count decisions
                let countAccept = 0, countAcceptWithComment = 0, countReject = 0;
                decisionsByReviewer.forEach(decisionSet => {
                    if (decisionSet.has('AcceptWithComment')) countAcceptWithComment++;
                    if (decisionSet.has('Accept')) countAccept++;
                    if (decisionSet.has('Reject') || decisionSet.has('RejectWithComment')) countReject++;
                });

                const Accepted = countAccept;
                const totalAcceptWithComment = countAcceptWithComment;
                const totalReject = countReject;

                setSummary({ Accepted, AcceptWithComment: totalAcceptWithComment, totalReject });

                // Button logic
                let shouldAccept = Accepted >= 3;
                let shouldRejected = totalReject >= 2;
                let shouldResubmit = false;

                const title = reviewsData.length > 0 ? reviewsData[0].SubmissionTitle : '';

                if (!shouldAccept && !shouldRejected) {
                    if (title.includes("Abstract")) {
                        setRevisionBtnName("Submit Full Paper");
                        // alert("paper accepted as Abstract paper")
                        if (Accepted >= 2 || totalAcceptWithComment >= 2) shouldResubmit = true;
                    } else if (title.includes("Full_Paper")) {
                        setRevisionBtnName("Submit Revision Paper");
                        if (Accepted < 3 && totalReject < 2) shouldResubmit = true;
                    } else if (title.includes("Revision")) {
                        setRevisionBtnName("Submit Revision Paper");
                        if (Accepted < 3 && totalReject < 2) shouldResubmit = true;
                    }
                }

                setBtnsVisiable({ accept: shouldAccept, revision: shouldResubmit, reject: shouldRejected });
            })
            .catch(err => console.error(err));
    }, [selectedSubmissionId, API]);



    const [showScheduleBtns, setShowScheduleBtns] = useState(false);
    const [progressData, setProgressData] = useState(null);

const handleStatusChange = async (status) => {
    if (!selectedSubmissionId) {
        alert('Please select a submission.');
        return;
    }

    try {
        const res = await axios.put(`${API}/api/reviewer-comments/update-status`, {
            submissionID: selectedSubmissionId,
            Status: status
        });

        
        if (status === "Pending") {
            alert('Full Paper submission initiated successfully!');
        } else if (status === "Accept" || status === "AcceptWithComment") {
            alert('Paper accepted successfully! Please schedule this paper.');
            setShowScheduleBtns(true);
            setProgressData({
                ProgressID: null,
                AuthorID: selectedAuthorId,
                SubmissionID: selectedSubmissionId,
                PlatformID: platformId,
                PaperSubmitted: true,
                SubmissionRegistered: true,
                ReviewerAssigned: true,
                CommentsShared: true,
                RepliesUpload: true,
                RevisionUpload: status === "AcceptWithComment",
                SubmissionAccepted: true,
                Scheduled: false,
                Released: false
            });
        } else if (status === "Reject") {
            alert('❌ Paper has been rejected.');
        }

        // 🔄 Refresh the review data
        const updated = await axios.get(`${API}/api/review-replies/reviews/${selectedSubmissionId}`);
        setReviews(updated.data.reviews || []);

    } catch (err) {
        console.error(err);
        alert('Failed to update submission status.');
    }
};



    const handlePendingClick = (authorId, submissionID, reviewerID) => {

        navigate(`/host/Change-reviewer/${submissionID}`, {
            state: { authorId, reviewerID }  // pass them via react-router state for example
        });
    };

    // Schedule Paper
    const handleSchedulePaper = async () => {
        if (!progressData) return alert('Missing progress data.');
        try {
            await axios.put(`${API}/api/reviewer-comments/update-status`, {
                submissionID: selectedSubmissionId,
                Status: 'Schedule'
            });
            alert('Paper scheduled successfully!');
            setShowScheduleBtns(false);
        } catch (err) {
            console.error(err);
            alert('Failed to schedule the paper.');
        }
    };

    // Hold Paper
    const handleHoldPaper = async () => {
        if (!progressData) return alert('Missing progress data.');
        try {
            await axios.put(`${API}/api/reviewer-comments/update-status`, {
                submissionID: selectedSubmissionId,
                Status: 'Hold'
            });
            alert('Paper put on hold!');
            setShowScheduleBtns(false);
        } catch (err) {
            console.error(err);
            alert('Failed to hold the paper.');
        }
    };



    return (
        <div className="container my-4 ml-2">
            <h3 className="page-title mb-4">📄 Review Replies List</h3>

            {/* 🟢 NEW FILTERS */}
            <div className="row mb-3">
                <div className="col-md-6">
                    <label>Filter by Status</label>
                    <select
                        className="form-select"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                    >
                        <option value="All">All</option>
                        <option value="Pending">Pending</option>
                        <option value="Accept">Accept</option>
                        <option value="Reject">Reject</option>
                    </select>
                </div>

                <div className="col-md-6">
                    <label>Filter by Type</label>
                    <select
                        className="form-select"
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                    >
                        <option value="All">All</option>
                        <option value="Abstract">Abstract</option>
                        <option value="Full_Paper">Full Paper</option>
                        <option value="Revision">Revision</option>
                    </select>
                </div>
            </div>

            {/* 🔍 Searchable Author Dropdown */}
            <div className="mb-3 position-relative">
                <label>Select Author</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search or select author..."
                    value={
                        selectedAuthorId
                            ? authors.find(a => a.AuthorID === selectedAuthorId)?.AuthorName || ""
                            : authorSearch
                    }

                    onChange={(e) => {
                        setSelectedAuthorId(""); // reset selected if typing
                        setAuthorSearch(e.target.value);
                    }}
                    onFocus={() => setShowAuthorDropdown(true)}
                    onBlur={() => setTimeout(() => setShowAuthorDropdown(false), 200)} // close dropdown after small delay
                />
                {showAuthorDropdown && (
                    <ul className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                        {authors
                            .filter(a => a.AuthorName.toLowerCase().includes(authorSearch.toLowerCase()))
                            .map(a => (
                                <li
                                    key={a.AuthorID}
                                    className="list-group-item list-group-item-action"
                                    onClick={() => {
                                        setSelectedAuthorId(a.AuthorID);
                                        setAuthorSearch(a.AuthorName);
                                        setShowAuthorDropdown(false);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {a.AuthorName}
                                </li>
                            ))}
                        {authors.filter(a => a.AuthorName.toLowerCase().includes(authorSearch.toLowerCase())).length === 0 && (
                            <li className="list-group-item text-muted">No authors found</li>
                        )}
                    </ul>
                )}
            </div>

            {/* Searchable Submission Dropdown */}
            <div className="mb-3 position-relative">
                <label>Select Submission</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search or select submission..."
                    value={
                        selectedSubmissionId
                            ? submissions.find(s => s.submissionID === selectedSubmissionId)?.SubmissionTitle || ""
                            : submissionSearch
                    }
                    onChange={(e) => {
                        setSelectedSubmissionId(""); // reset selected if typing
                        setSubmissionSearch(e.target.value);
                    }}
                    onFocus={() => setShowSubmissionDropdown(true)}
                    onBlur={() => setTimeout(() => setShowSubmissionDropdown(false), 200)}
                />
                {showSubmissionDropdown && (
                    <ul className="list-group position-absolute w-100 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                        {submissions
                            .filter(s => s.SubmissionTitle.toLowerCase().includes(submissionSearch.toLowerCase()))
                            .map(s => (
                                <li
                                    key={s.submissionID}
                                    className="list-group-item list-group-item-action"
                                    onClick={() => {
                                        setSelectedSubmissionId(s.submissionID);
                                        setSubmissionSearch(s.SubmissionTitle);
                                        setShowSubmissionDropdown(false);
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {s.SubmissionTitle}
                                </li>
                            ))}
                        {submissions.filter(s => s.SubmissionTitle.toLowerCase().includes(submissionSearch.toLowerCase())).length === 0 && (
                            <li className="list-group-item text-muted">No submissions found</li>
                        )}
                    </ul>
                )}
            </div>

            <div className="alert alert-secondary">
                <strong> Accepted:</strong> {summary.Accepted} |
                <strong> Accept With comments:</strong> {summary.AcceptWithComment} |
                <strong> Total Reject:</strong> {summary.totalReject} |
                <strong > Accepted weightage:</strong> {((summary.Accepted - summary.totalReject)).toFixed(1)}

            </div>

            {/*sujay 3/6/2025 adding pdf column  */}
            {/* getting file name at 0th index */}
            {reviews.length > 0 && (
                <div className="row">
                    <div className="col-xl">
                        {reviews && reviews[0].File && reviews[0].File.endsWith('.pdf') ? (
                            <div className="border mb-3" style={{ height: '600px' }}>
                                <Worker workerUrl="/pdf.worker.min.js">
                                    <Viewer
                                        fileUrl={`${API}/uploads/papers/${reviews[0].File}`}
                                        plugins={[defaultLayoutPluginInstance]}
                                    />
                                </Worker>
                            </div>
                        ) : (
                            <div className="alert alert-warning">File is not a valid PDF</div>
                        )}

                        {/* Sujay 10/6/2025 hiding the btn if paper has revision paper of it */}

                        {!isParent && isReview.includes("Reviewing") ?
                            <div className="mb-3">

                                {showScheduleBtns && progressData && (
                                    <div className="mb-3">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleSchedulePaper}
                                        >
                                            Schedule
                                        </button>

                                        <button
                                            className="btn btn-secondary me-2"
                                            onClick={handleHoldPaper}
                                        >
                                            Hold
                                        </button>
                                    </div>
                                )}

                                {(btnsVisiable.accept && !isParent) &&
                                    <button className="btn btn-success me-2" onClick={() => handleStatusChange('Accept')}>Accept</button>
                                }
                                {btnsVisiable.revision &&
                                    <button className="btn btn-warning me-2" onClick={() => handleStatusChange('Pending')}>{revisionBtnName}</button>
                                }
                                {btnsVisiable.reject &&
                                    <button className="btn btn-danger me-2" onClick={() => handleStatusChange('Reject')}>Reject Paper</button>
                                }
                                <button hidden className="btn btn-info me-2" onClick={() => handleStatusChange('RepliesUploaded')}>Mark Replies Uploaded</button>
                            </div> : <div class="alert alert-info fw-bold text-center mb-3 rounded shadow-sm" role="alert">
                                Action already taken
                            </div>

                        }
                    </div>
                    {/* //Sujay 12/6/2025 adding the table like structure */}
                    <div className="col-sm">
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>Reviewer</th>
                                    <th>Comment</th>
                                    <th>Decision</th>
                                    <th>Review Date</th>
                                    <th>Replied On</th>
                                    <th>Author Reply</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reviews.map((r, index) => (
                                    <tr key={index}>
                                        <td>{r.ReviewerName || r.ReviewerID}</td>
                                        <td><strong>{r.Comment}</strong></td>
                                        <td>
                                            {r.Decision ? (
                                                <span
                                                    className={
                                                        r.Decision === 'AcceptWithComment' ? 'text-success fw-bold'
                                                            : r.Decision === 'Accept' ? 'text-success fw-bold'
                                                                : r.Decision === 'Reject' || r.Decision === 'RejectWithComment'
                                                                    ? 'text-danger fw-bold'
                                                                    : 'text-warning fw-bold'
                                                    }
                                                >
                                                    {r.Decision === 'AcceptWithComment' ? 'Comment' : r.Decision}
                                                </span>
                                            ) : (
                                                <button
                                                    className="btn btn-sm btn-warning"
                                                    onClick={() => handlePendingClick(selectedAuthorId, selectedSubmissionId, r.ReviewerID)}
                                                >
                                                    Pending
                                                </button>

                                            )}
                                        </td>


                                        <td>{r.ReviewDate && new Date(r.ReviewDate).toLocaleDateString()}</td>
                                        <td>{r.AuthorReplayDate && new Date(r.AuthorReplayDate).toLocaleDateString()}</td>
                                        <td>{r.AuthorReply && <strong>{r.AuthorReply}</strong>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReviewRepliesList;

